import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  Index,
  JoinColumn,
  ManyToOne,
  JoinTable,
  ManyToMany,
  OneToMany
} from "typeorm";
import { Organization, Permission, LicenseRequest, StripeOrder } from ".";
import { Role } from "./Role";

@Entity()
export class User {
  @PrimaryGeneratedColumn() id: number;

  @Column("varchar") username: string;
  @Column("varchar") firstName: string;
  @Column("varchar") lastName: string;
  @Column("varchar") email: string;
  @Column("varchar") address1: string;
  @Column("varchar") address2: string;
  @Column("varchar") city: string;
  @Column("varchar") state: string;
  @Column("varchar") zip: string;
  @Column("varchar") town: string;
  @Column("varchar") county: string;
  @Column("varchar") phone: string;
  @Column("varchar") postcode: string;
  @Column("varchar", { default: "ACTIVE" })
  status: string;
  @Column("varchar", { length: 5, nullable: true })
  region: string | null;

  @ManyToOne(() => Role)
  role: Role;

  @Column("int") organizationId: number;

  @ManyToOne(() => Organization, organization => organization.users)
  organization: Organization;

  @ManyToMany(() => Permission)
  @JoinTable()
  permissions: Permission[];

  @Index({ unique: true })
  @Column("varchar")
  sub: string;

  @OneToMany(() => LicenseRequest, licenseRequest => licenseRequest.user)
  @JoinColumn()
  licenseRequests: LicenseRequest[];

  @OneToMany(() => StripeOrder, stripeOrder => stripeOrder.user)
  @JoinColumn()
  stripeOrders: StripeOrder[];

  @Column("varchar", { nullable: true }) notifications: string | null;

  @ManyToOne(() => User)
  @JoinColumn()
  createdBy: User;

  @ManyToOne(() => User)
  @JoinColumn()
  updatedBy: User;

  @Column("datetime") createdAt: Date;
  @Column("datetime") updatedAt: Date;
}
